import React from 'react';
import styled from 'styled-components';

import { SettingHeader, SettingsContainer } from './BranchComponents';
import BranchStaticField from './BranchStaticField';
import Switch from '../../Shared/Switch';

import { withFund } from '../../../utils/formatters';
import { isCommissionSet } from '../../../helpers';

const RxCommissionsSettings = ({
  pharmacy,
  organisation,
  globalCommissionRates,
  onChange,
  onValidationError
}) => {
  const { delivery_partner } = pharmacy;
  const { rx_referral_commission } = delivery_partner || {};
  const { commissions = {} } = organisation || {};
  const { defaultRate } = commissions;
  const { delivery: orgDeliveryCommission, collect: orgCollectCommission } = defaultRate || {};
  const {
    collect: globalCollectCommission,
    delivery: globalDeliveryCommission
  } = globalCommissionRates || {};

  const isChargingOrgDeliveryCommission = isCommissionSet(orgDeliveryCommission);
  const isChargingOrgCollectCommission = isCommissionSet(orgCollectCommission);

  const isChargingGlobalRates = !(
    isChargingOrgDeliveryCommission || isChargingOrgCollectCommission
  );

  const pharmacyCommissions = {
    delivery: isChargingOrgDeliveryCommission ? orgDeliveryCommission : globalDeliveryCommission,
    collect: isChargingOrgCollectCommission ? orgCollectCommission : globalCollectCommission
  };

  const handleReferralCommissionSwitch = (_, checked) => {
    onChange('delivery_partner.rx_referral_commission', checked);
  };

  return (
    <SettingsContainer>
      <SettingHeader>Commissions on Rx Items</SettingHeader>
      <Switch
        checked={!!rx_referral_commission}
        onChange={handleReferralCommissionSwitch}
        label="Paying Commissions on Rx Items and Available to Referred Patients"
      />
      <Switch disabled checked={isChargingGlobalRates} label="Charging Global Rates" />
      <StaticField label="Collection Items" value={withFund(pharmacyCommissions.collect)} />
      <StaticField label="Delivery Items" value={withFund(pharmacyCommissions.delivery)} />
    </SettingsContainer>
  );
};

const StaticField = styled(BranchStaticField)`
  && {
    margin-bottom: 8px;
  }
`;

export default RxCommissionsSettings;
